import { ClientWebPageQueryParams } from '@common/model/meta/clientWebPageQueryParams';
import { UpdateQueryParams } from '@cp/shared/queryParams';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { useCallback, useMemo } from 'react';
import { Sorters } from '@common/model/sortable';
import { CatalogSorters } from '@common/model/catalog/item/type';
import { CatalogSortingTypes } from 'src/entities/catalog/model/types';
import { catalogSortingValues } from '../const';
import { getCatalogSortingType } from '../utils/getCatalogSortingType';

const defaultSorters: Record<CatalogSorters, undefined> = {
  age: undefined,
  createdAt: undefined,
  expirience: undefined,
  matchedAt: undefined,
  price: undefined,
  reviewsCount: undefined,
};

export const useCatalogSorters = ({
  queryParams,
  updateQueryParams,
}: {
  queryParams: ClientWebPageQueryParams<ClientWebPage.Catalog>;
  updateQueryParams: UpdateQueryParams<ClientWebPageQueryParams<ClientWebPage.Catalog>>;
}) => {
  const setSorters = useCallback(
    (sorters?: Sorters<`${CatalogSorters}`> | null) => {
      updateQueryParams({
        sorters: sorters || undefined,
      });
    },
    [updateQueryParams],
  );
  const onSorting = useCallback((sorting?: CatalogSortingTypes) => {
    const sortingValue = catalogSortingValues[sorting || CatalogSortingTypes.Normal];
    setSorters(
      sortingValue
        ? {
            ...defaultSorters,
            [sortingValue.name]: sortingValue.direction,
          }
        : null,
    );
  }, []);
  const sorting = useMemo(() => {
    if (!queryParams.sorters) {
      return CatalogSortingTypes.Normal;
    }

    let value: CatalogSortingTypes | null = null;
    for (const key in queryParams.sorters) {
      if (!value) {
        value = getCatalogSortingType(key, queryParams.sorters[key]);
      }
    }
    return value ? value : CatalogSortingTypes.Normal;
  }, [queryParams.sorters]);
  return { sorters: queryParams.sorters || null, setSorters, onSorting, sorting };
};
